import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-entfernen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenDokumentEntfernenEffects {

    DokumentEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_ENTFERNEN),
        mergeMap((x: ac.PostDokumentEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentEntfernen(x.dokumentEntfernenRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentEntfernenErfolgreichAction(result, x.dokumentEntfernenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentEntfernenFehlerAction(error, x.dokumentEntfernenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumenteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumenteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumenteCommandService);
        }
        return this.service;
    }
}
